import { ReactElement, useEffect, useState } from 'react';
import { getAuthToken, isAuthenticated } from '../utils/authSession';
import { getUserDashboard } from '../services/userService';
import { TailSpin } from "react-loader-spinner";
import { hasActiveSubscription as hasActiveSubscriptionStatus } from '../utils/subscriptionStatus';


export const SubscriptionRoute = ({ children }: { children: ReactElement }): ReactElement => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasActiveSubscription, setHasActiveSubscription] = useState(false);

  useEffect(() => {
    const checkSubscription = async () => {
      if (!isAuthenticated()) {
        setIsLoading(false);
        return;
      }

      const token = getAuthToken();
      if (!token) {
        setIsLoading(false);
        return;
      }

      try {
        const response = await getUserDashboard(token);
        const subscriptions = response.data.subscriptions || [];
        setHasActiveSubscription(hasActiveSubscriptionStatus(subscriptions));
      } catch (error) {
        console.error('Failed to check subscription:', error);
        setHasActiveSubscription(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkSubscription();
  }, []);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#F4F5F7]">
        <TailSpin color="rgb(17,58,40)" height={80} width={80} />
      </div>
    );
  }

  if (!isAuthenticated()) {
    window.location.replace('/pricing/');
    return <></>;
  }

  if (!hasActiveSubscription) {
    window.location.replace('/pricing/');
    return <></>;
  }

  return children;
};
